import React, { useState, useEffect } from "react";

import './Summary.css'; // Summary page styles

const CybersourceCheckout = ({ student, amount, currency,referenceNumber }) => {
  const [formData, setFormData] = useState({


    // production
    
    access_key: "3d504875321c3d7d99d6b8f044755a29",
    profile_id: "28058D22-5675-4766-9A71-887A5AA9C5A4",

    // test
    // access_key: "e6417097589a39e68c60795bf48d543a",
    // profile_id: "CDBF4C39-0165-4E19-98AB-1D148E38A7AA",
    // access_key: "e6417097589a39e68c60795bf48d543a",
    // //access_key: "e6417097589a39e68c60795bf48d543a",
    // profile_id: "28058D22-5675-4766-9A71-887A5AA9C5A4",
    //profile_id: "CDBF4C39-0165-4E19-98AB-1D148E38A7AA",
    transaction_uuid: generateUUID(),
    currency,
    locale: "en",
    amount,
    signed_date_time: new Date().toISOString().replace(/\.\d+Z$/, 'Z'),
    //reference_number: "ada12345678wert936243swe12",
    reference_number: referenceNumber, // Use studentNumber as reference
    transaction_type: "sale",
    bill_to_forename:  student.FirstName,
    bill_to_address_city: "Lusaka",
    bill_to_address_country: "ZM",
    bill_to_address_line1: "Not applicable",
    bill_to_surname: student.LastName,
    bill_to_email: "johndoe@example.com",
    signed_field_names: "access_key,profile_id,transaction_uuid,currency,locale,amount,signed_date_time,transaction_type,reference_number,bill_to_forename,bill_to_address_line1,bill_to_address_city,bill_to_address_country,bill_to_surname,bill_to_email,signed_field_names,unsigned_field_names",
    unsigned_field_names: "",
    signature: ""
  });

  function generateUUID() {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }

  useEffect(() => {
    const fetchSignature = async () => {
      try {
        const response = await fetch("https://app.unilus.ac.zm/api/getSignature", {
        //const response = await fetch("http://localhost:5000/api/getSignature", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
        const data = await response.json();
        if (data.signature) {
          setFormData((prev) => ({ ...prev, signature: data.signature }));
        } else {
          console.error("Signature not returned from server:", data);
        }
      } catch (error) {
        console.error("Error fetching signature:", error);
      }
    };

    fetchSignature();
  }, [formData.signed_date_time]);

  return (
    <form method="POST" action="https://secureacceptance.cybersource.com/pay" id="cybersourceForm">
    {/* <form method="POST" action="https://testsecureacceptance.cybersource.com/pay" id="cybersourceForm"> */}
      {Object.keys(formData).map((field) => (
        <input key={field} type="hidden" name={field} value={formData[field]} />
      ))}
      <button type="submit">Pay Now</button>
    </form>
  );
};

export default CybersourceCheckout;
